// React & Router
import React, { Component } from 'react';
import { Link } from 'react-router-dom';

// HTTP client
import axios from 'axios';

// sweetalert2
import Swal from 'sweetalert2'
import $ from 'jquery';

// Bootstrap UI
import { Row, Col, Breadcrumb, Image as Images } from 'react-bootstrap';

// RSuite UI
import {
    VStack, HStack, Stack, Divider, Button, IconButton,
    SelectPicker, Text, InputNumber, MaskedInput, Input,
    Panel, Loader, RadioGroup, Radio, Modal
} from 'rsuite';

// Cropper
import Cropper from 'react-easy-crop'

// Thai Date Picker
import { ThaiDatePicker } from 'thaidatepicker-react';

export default class EditPage extends Component {

    constructor(props) {
        super(props);
        this.state = {
            content: null,
            year: '',
            loading: false,
            ethnics: [],
            provinces: [],
            amphures: [],
            tambons: [],
            villages: [],
            reg_province_selection: [],
            reg_amphur_selection: [],
            reg_tambon_selection: [],
            temp_province_selection: [],
            temp_amphur_selection: [],
            temp_tambon_selection: [],
            id: '',
            image: null,
            croppedImage: null,
            croppedArea: null,
            crop: { x: 0, y: 0 },
            zoom: 1,
            rotation: 0,
            path: '',
            prefix: '',
            first_name: '',
            last_name: '',
            nickname: '',
            id_card_number: '',
            date_of_birth: '',        // เก็บเป็น string หรือ Date object ก็ได้
            ethnicity: '',
            phone: '',
            reg_house_number: '',
            reg_village_no: '',
            reg_village: '',
            reg_village_name: '',
            reg_province_id: 0,       // id มักเป็นตัวเลข
            reg_amphur_id: 0,
            reg_tambon_id: 0,
            is_reg_address: 'yes',    // เป็น boolean
            temp_house_number: '',
            temp_village_no: '',
            temp_village: '',
            temp_village_name: '',
            temp_province_id: 0,
            temp_amphur_id: 0,
            temp_tambon_id: 0,
            father_full_name: '',
            father_age: 0,
            father_phone: '',
            father_occupation: '',
            father_workplace: '',
            mother_full_name: '',
            mother_age: 0,
            mother_phone: '',
            mother_occupation: '',
            mother_workplace: '',
            parent_status: '',
            parent_status_1: '',
            parent_status_2: '',
            parent_status_3: '',
            parent_status_4: '',
            contactable: '',
            relationship_to_applicant: '',
            total_siblings: 0,
            working_siblings: 0,
            siblings_in_school: 0,
            unemployed_siblings: 0,
            siblings_not_of_age: 0,
            family_income_per_year: 0,
            provider_full_name: '',
            provider_relationship: '',
            is_family_residence: 'no',
            family_residence_rai: 0,
            family_residence_ngan: 0,
            family_residence_wah: 0,
            is_none_residence: 'no',
            none_residence_rai: 0,
            none_residence_ngan: 0,
            none_residence_wah: 0,
            is_family_work: 'no',
            family_work_rai: 0,
            family_work_ngan: 0,
            family_work_wah: 0,
            is_none_work: 'no',
            none_work_rai: 0,
            none_work_ngan: 0,
            none_work_wah: 0
        };
    }

    async componentDidMount() {
        const logged = JSON.parse(localStorage.getItem('logged') || '{}');
        const token = logged?.user?.token;
        const userId = logged?.user?.user?.id;

        if (!token || !userId) {
            return (window.location.href = '/login');
        }

        const authHeader = {
            headers: { Authorization: `Bearer ${token}` }
        };

        await this.promisedSetState({ authHeader });

        try {
            const { data } = await axios.get(
                `${process.env.REACT_APP_API}/application/latest/${userId}`,
                authHeader
            );

            await this.onRenderContent({ mode: 'read', data });
        } catch (error) {
            console.error('Failed to fetch application data:', error);
            // Optional: redirect, show error, etc.
        }
    }

    // Promise-based setState
    promisedSetState = (newState) => new Promise(resolve =>
        this.setState(newState, resolve)
    );

    fetchEthnics = async ({ mode }) => {
        if (mode === 'read') {
            try {
                const res = await axios.get(`${process.env.REACT_APP_API}/ethnics`, this.state.authHeader);
                const ethnics = res.data.map(e => ({ label: e.name, value: e.name }));
                await this.promisedSetState({ ethnics });
            } catch (err) {
                console.error("Error fetching ethnics:", err);
            }
        }
    };

    fetchVillages = async ({ mode }) => {
        if (mode === 'read') {
            try {
                const res = await axios.get(`${process.env.REACT_APP_API}/villages`, this.state.authHeader);
                const villages = res.data.map(v => ({ label: v.name, value: v.name }));
                villages.push({ label: 'อื่นๆ (โปรดระบุ)', value: 'other' });
                await this.promisedSetState({ villages });
            } catch (err) {
                console.error("Error fetching villages:", err);
            }
        }
    };

    fetchProvinces = async ({ mode }) => {
        if (mode === 'read') {
            try {
                const res = await axios.get(`${process.env.REACT_APP_API}/provinces`, this.state.authHeader);
                const provinces = res.data.map(p => ({ label: p.name_th, value: p.id }));
                await this.promisedSetState({
                    reg_province_selection: provinces,
                    temp_province_selection: provinces
                });
            } catch (err) {
                console.error('Error fetching provinces:', err);
            }
        }
    };

    fetchAmphures = async (amphureKey, tambonKey, provinceId) => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API}/amphures/${provinceId}`, this.state.authHeader);
            const data = res.data.map(a => ({ label: a.name_th, value: a.id }));
            await this.promisedSetState({ [amphureKey]: data, [tambonKey]: [] });
        } catch (err) {
            console.error('Error fetching amphures:', err);
        }
    };

    fetchTambons = async (tambonKey, amphureId) => {
        try {
            const res = await axios.get(`${process.env.REACT_APP_API}/tambons/${amphureId}`, this.state.authHeader);
            const data = res.data.map(t => ({ label: t.name_th, value: t.id }));
            await this.promisedSetState({ [tambonKey]: data });
        } catch (err) {
            console.error('Error fetching tambons:', err);
        }
    };

    handleProvinceChange = async ({ value, amphureKey, tambonKey, data }) => {
        try {
            await this.fetchAmphures(amphureKey, tambonKey, value);
            await this.onRenderContent({ mode: 'read' });
        } catch (err) {
            console.error('Error handling province change:', err);
        }
    };

    handleAmphureChange = async ({ value, tambonKey, data }) => {
        try {
            await this.fetchTambons(tambonKey, value);
            await this.onRenderContent({ mode: 'read' });
        } catch (err) {
            console.error('Error handling amphure change:', err);
        }
    };

    to2decimal = (value) => {
        return `${(value * 1).toFixed(2).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}`
    }

    toInterger = (value) => {
        return `${(value * 1).toFixed(0).replace(/\d{1,3}(?=(\d{3})+(\.\d*)?$)/g, '$&,')}`
    }

    // Trigger file input click
    onSelectedImage = () => {
        const input = document.getElementById('InputImageUpload');
        if (input) input.click();
    };

    // When cropping is complete, store cropped pixel area
    onCropComplete = (croppedAreaPercentage, croppedAreaPixels) => {
        this.setState({ croppedArea: croppedAreaPixels });
    };

    // Handle file selection, load image, and open modal
    onSelectFile = async ({ event, mode }) => {
        const file = event.target.files?.[0];
        if (!file) return;

        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = async () => {
            await this.promisedSetState({ image: reader.result });
            await this.onModal({ mode: 'read' });
        };
    };

    // Load image as HTMLImageElement from URL
    createImage = (url) => {
        return new Promise((resolve, reject) => {
            const img = new Image();
            img.crossOrigin = 'anonymous';
            img.onload = () => resolve(img);
            img.onerror = reject;
            img.src = url;
        });
    };

    // Convert degrees to radians
    getRadianAngle = (degree) => (degree * Math.PI) / 180;

    // Crop image to base64
    getCroppedImageBase64 = async (imageSrc, pixelCrop, rotation = 0) => {
        const image = await this.createImage(imageSrc);
        const canvas = document.createElement("canvas");
        const ctx = canvas.getContext("2d");

        const maxSize = Math.max(image.width, image.height);
        const safeArea = 2 * (maxSize / 2) * Math.sqrt(2);

        canvas.width = canvas.height = safeArea;

        ctx.translate(safeArea / 2, safeArea / 2);
        ctx.rotate(this.getRadianAngle(rotation));
        ctx.translate(-safeArea / 2, -safeArea / 2);
        ctx.drawImage(
            image,
            safeArea / 2 - image.width / 2,
            safeArea / 2 - image.height / 2
        );

        const imageData = ctx.getImageData(0, 0, safeArea, safeArea);

        canvas.width = pixelCrop.width;
        canvas.height = pixelCrop.height;

        ctx.putImageData(
            imageData,
            -safeArea / 2 + image.width / 2 - pixelCrop.x,
            -safeArea / 2 + image.height / 2 - pixelCrop.y
        );

        return canvas.toDataURL("image/jpeg");
    };

    // Convert base64 string to Blob
    base64ToBlob = async (base64String, contentType = 'image/jpeg') => {
        try {
            const base64Data = base64String.split(',')[1]; // remove prefix like "data:image/jpeg;base64,"
            const byteCharacters = atob(base64Data);
            const byteNumbers = Array.from(byteCharacters, char => char.charCodeAt(0));
            const byteArray = new Uint8Array(byteNumbers);
            return new Blob([byteArray], { type: contentType });
        } catch (err) {
            throw new Error('Failed to convert base64 to Blob');
        }
    };

    onModal = async ({ mode }) => {
        if (mode !== 'read') return;

        const handleCropChange = (crop) => this.setState({ crop });
        const handleZoomChange = (zoom) => this.setState({ zoom });
        const handleCropComplete = (_, croppedArea) => this.setState({ croppedArea });

        const handleConfirm = async () => {
            await this.promisedSetState({ loading: true });
            const croppedImage = await this.getCroppedImageBase64(this.state.image, this.state.croppedArea, 0);
            await this.promisedSetState({ croppedImage, modal: null, loading: false });
            await this.onRenderContent({ mode });
        };

        this.setState({
            modal: (
                <Modal size="md" open={true} onClose={() => this.setState({ modal: null })}>
                    <Modal.Body>
                        <div style={{ width: '100%', height: '600px' }}>
                            <Cropper
                                image={this.state.image}
                                crop={this.state.crop}
                                zoom={this.state.zoom}
                                aspect={0.8 / 1}
                                onCropChange={handleCropChange}
                                onZoomChange={handleZoomChange}
                                onCropComplete={handleCropComplete}
                            />
                        </div>
                    </Modal.Body>
                    <Modal.Footer className="p-2">
                        <Button onClick={handleConfirm} appearance="primary" startIcon={<i className="bi bi-check2-square"></i>}>
                            ยืนยัน
                        </Button>
                        <Button onClick={() => this.setState({ modal: null })} appearance="subtle">
                            ยกเลิก
                        </Button>
                    </Modal.Footer>
                </Modal>
            )
        });
    };

    onRenderContent = async ({ mode, data }) => {
        console.log(JSON.stringify(data))
        if (mode === 'read') {
            try {
                await this.promisedSetState({ loading: true })

                if (data) {
                    await this.promisedSetState({
                        id: data.id,
                        croppedImage: `${process.env.REACT_APP_UPLOAD}/${data.path}`,
                        prefix: data.prefix,
                        first_name: data.first_name,
                        last_name: data.last_name,
                        nickname: data.nickname,
                        id_card_number: data.id_card_number,
                        date_of_birth: data.date_of_birth,
                        ethnicity: data.ethnicity,
                        phone: data.phone,

                        // ที่อยู่ตามทะเบียนบ้าน
                        reg_house_number: data.reg_house_number,
                        reg_village_no: data.reg_village_no,
                        reg_village: data.reg_village,
                        reg_village_name: data.reg_village_name,
                        reg_province_id: data.reg_province_id,
                        reg_amphur_id: data.reg_amphur_id,
                        reg_tambon_id: data.reg_tambon_id,
                        is_reg_address: data.is_reg_address,

                        // ที่อยู่ปัจจุบัน
                        temp_house_number: data.temp_house_number,
                        temp_village_no: data.temp_village_no,
                        temp_village: data.temp_village,
                        temp_village_name: data.temp_village_name,
                        temp_province_id: data.temp_province_id,
                        temp_amphur_id: data.temp_amphur_id,
                        temp_tambon_id: data.temp_tambon_id,

                        // ข้อมูลบิดา
                        father_full_name: data.father_full_name,
                        father_age: data.father_age,
                        father_phone: data.father_phone,
                        father_occupation: data.father_occupation,
                        father_workplace: data.father_workplace,

                        // ข้อมูลมารดา
                        mother_full_name: data.mother_full_name,
                        mother_age: data.mother_age,
                        mother_phone: data.mother_phone,
                        mother_occupation: data.mother_occupation,
                        mother_workplace: data.mother_workplace,

                        // ข้อมูลผู้ปกครอง
                        parent_status: data.parent_status,
                        parent_status_1: data.parent_status_1,
                        parent_status_2: data.parent_status_2,
                        parent_status_3: data.parent_status_3,
                        parent_status_4: data.parent_status_4,
                        contactable: data.contactable,
                        relationship_to_applicant: data.relationship_to_applicant,

                        // พี่น้อง
                        total_siblings: data.total_siblings,
                        working_siblings: data.working_siblings,
                        siblings_in_school: data.siblings_in_school,
                        unemployed_siblings: data.unemployed_siblings,
                        siblings_not_of_age: data.siblings_not_of_age,

                        // รายได้ครอบครัว
                        family_income_per_year: data.family_income_per_year,
                        provider_full_name: data.provider_full_name,
                        provider_relationship: data.provider_relationship,

                        // ที่ดินที่อยู่อาศัย (มี)
                        is_family_residence: data.is_family_residence,
                        family_residence_rai: data.family_residence_rai,
                        family_residence_ngan: data.family_residence_ngan,
                        family_residence_wah: data.family_residence_wah,

                        // ที่ดินทำกิน (มี)
                        is_family_work: data.is_family_work,
                        family_work_rai: data.family_work_rai,
                        family_work_ngan: data.family_work_ngan,
                        family_work_wah: data.family_work_wah,

                        // ที่ดินที่อยู่อาศัย (ไม่มี)
                        is_none_residence: data.is_none_residence,
                        none_residence_rai: data.none_residence_rai,
                        none_residence_ngan: data.none_residence_ngan,
                        none_residence_wah: data.none_residence_wah,

                        // ที่ดินทำกิน (ไม่มี)
                        is_none_work: data.is_none_work,
                        none_work_rai: data.none_work_rai,
                        none_work_ngan: data.none_work_ngan,
                        none_work_wah: data.none_work_wah,
                    });

                    await Promise.all([
                        this.fetchEthnics({ mode }),
                        this.fetchVillages({ mode }),
                        this.fetchProvinces({ mode }),
                        this.fetchAmphures('reg_amphur_selection', 'reg_tambon_selection', data.reg_province_id),
                        this.fetchTambons('reg_tambon_selection', data.reg_amphur_id),
                        this.fetchAmphures('temp_amphur_selection', 'temp_tambon_selection', data.temp_province_id),
                        this.fetchTambons('temp_tambon_selection', data.temp_amphur_id),
                    ]);
                }

                // Setting state using promisedSetState
                await this.promisedSetState({
                    content: <>
                        <Row className='mt-3'>
                            <Col>
                                <Breadcrumb size='lg' >
                                    <Breadcrumb.Item><Link to="/admin"><i className="bi bi-house-fill"></i></Link></Breadcrumb.Item>
                                    <Breadcrumb.Item active>ประวัติส่วนตัว</Breadcrumb.Item>
                                </Breadcrumb>
                            </Col>
                        </Row>

                        <Row>
                            <Col lg={12} className='mb-3'>
                                <Panel
                                    header="ข้อมูลทั่วไป"
                                    className="shadow-sm"
                                    style={{ backgroundColor: '#FFF', padding: '1em', height: '100%' }}
                                >
                                    <Row className="mt-3">
                                        <Col lg={2} className="mb-3">
                                            <Stack
                                                className='cNlLu'
                                                spacing={6}
                                                direction={'column'}
                                                alignItems={'flex-start'}
                                            >
                                                <Images
                                                    className="border"
                                                    src={this.state.croppedImage}
                                                    rounded
                                                    fluid
                                                    width={142}
                                                    height={198} />
                                                <Button
                                                    size='sm'
                                                    color="green"
                                                    appearance="primary"
                                                    startIcon={<i class="bi bi-card-image"></i>}
                                                    onClick={() => this.onSelectedImage()}>กรุณาเลือกรูปภาพ</Button>
                                                <input
                                                    id='InputImageUpload'
                                                    type='file'
                                                    accept='image/*'
                                                    onChange={(e) => this.onSelectFile({ event: e, mode })}
                                                    hidden />
                                            </Stack>
                                        </Col>

                                        <Col lg={10} className="mb-3">
                                            <HStack>
                                                <VStack>
                                                    <label>คำนำหน้า <span style={{ color: 'red' }}>*</span></label>
                                                    <SelectPicker
                                                        className='tMeny'
                                                        size='lg'
                                                        data={[
                                                            { value: 'นาย', label: 'นาย' },
                                                            { value: 'นางสาว', label: 'นางสาว' }
                                                        ]}
                                                        defaultValue={this.state.prefix}
                                                        searchable={false}
                                                        style={{ width: 100 }}
                                                        placeholder="เลือก"
                                                        onChange={e => this.setState({ prefix: e })}
                                                        onClean={() => this.setState({ prefix: '' })}
                                                    />
                                                </VStack>

                                                <VStack>
                                                    <label>ชื่อ <span style={{ color: 'red' }}>*</span></label>
                                                    <Input
                                                        className='vKmhs'
                                                        size='sm'
                                                        defaultValue={this.state.first_name}
                                                        onChange={e => this.setState({ first_name: e })} />
                                                </VStack>

                                                <VStack>
                                                    <label>นามสกุล <span style={{ color: 'red' }}>*</span></label>
                                                    <Input
                                                        className='PA9y5'
                                                        size='sm'
                                                        defaultValue={this.state.last_name}
                                                        onChange={e => this.setState({ last_name: e })} />
                                                </VStack>

                                            </HStack>

                                            <VStack className='mt-3'>
                                                <label>ชื่อเล่น <span style={{ color: 'red' }}>*</span></label>
                                                <Input
                                                    className='AA0HY'
                                                    size='sm'
                                                    style={{ width: 120 }}
                                                    defaultValue={this.state.nickname}
                                                    onChange={e => this.setState({ nickname: e })} />
                                            </VStack>

                                            <VStack className='mt-3'>
                                                <label>เลขบัตรประชาชน <span style={{ color: 'red' }}>*</span></label>
                                                <MaskedInput
                                                    className='IoXlX mt-2'
                                                    size='sm'
                                                    mask={[/[0-9,Gg]/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/]}
                                                    guide={false}
                                                    showMask={[/[0-9,Gg]/, '-', /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/, /\d/, '-', /\d/, /\d/, '-', /\d/]}
                                                    keepCharPositions={true}
                                                    style={{ letterSpacing: '0.1em', width: '300px' }}
                                                    placeholderChar={'_'}
                                                    defaultValue={this.state.id_card_number}
                                                    onChange={e => this.setState({ id_card_number: e })}
                                                />
                                            </VStack>

                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col lg={2} className="mb-3">
                                            {/* No Something */}
                                        </Col>

                                        <Col lg={3} className="mb-3">
                                            <VStack>
                                                <label>วัน/เดือน/ปี เกิด <span style={{ color: 'red' }}>*</span></label>
                                                <div className='QA6Vy' style={{ display: 'flex', alignItems: 'center' }}>
                                                    <ThaiDatePicker
                                                        placeholder="วัน/เดือน/ปี พ.ศ."
                                                        value={this.state.date_of_birth}
                                                        inputProps={{
                                                            style: {
                                                                padding: '6px 8px',
                                                                borderRadius: '6px 0 0 6px',
                                                                border: '1px solid #E7E5E4',
                                                                width: '200px',
                                                            }
                                                        }}
                                                        onChange={async (e) => {
                                                            await this.promisedSetState({ date_of_birth: e });
                                                            await this.onRenderContent({ mode: 'read' });
                                                        }}
                                                        onClean={async () => {
                                                            await this.promisedSetState({ date_of_birth: '' });
                                                            await this.onRenderContent({ mode: 'read' });
                                                        }}
                                                    />
                                                    <IconButton
                                                        icon={<i className="bi bi-calendar3"></i>}
                                                        size="md"
                                                        style={{
                                                            borderRadius: '0 6px 6px 0', // top-left 0, top-right 6px, bottom-right 6px, bottom-left 0
                                                        }}
                                                    />
                                                </div>
                                            </VStack>
                                        </Col>

                                        <Col lg={6} className="mb-3">
                                            <VStack>
                                                <label>ชนเผ่า <span style={{ color: 'red' }}>*</span></label>
                                                <SelectPicker
                                                    className='0i8nv'
                                                    size='lg'
                                                    placeholder='กรุณาเลือก'
                                                    data={this.state.ethnics}
                                                    style={{ width: 224 }}
                                                    defaultValue={this.state.ethnicity}
                                                    onChange={e => this.setState({ ethnicity: e })}
                                                    onClean={() => this.setState({ ethnicity: '' })}
                                                />
                                            </VStack>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col lg={2} className="mb-3">
                                            {/* No Something */}
                                        </Col>

                                        <Col lg={10} className="mb-3">
                                            <VStack>
                                                <label>เบอร์โทรศัพท์ติดต่อ <span style={{ color: 'red' }}>*</span></label>
                                                <Input
                                                    className='y013L'
                                                    size='sm'
                                                    defaultValue={this.state.phone}
                                                    style={{ width: 250 }}
                                                    onChange={e => this.setState({ phone: e })} />
                                            </VStack>
                                        </Col>
                                    </Row>

                                    <Divider />

                                    <Text weight="bold">ข้อมูลที่อยู่อาศัย</Text>

                                    <Row className='mt-3'>
                                        <Col className="mb-3">
                                            <label className='mb-2'>ที่อยู่ตามทะเบียนบ้าน <span style={{ color: 'red' }}>*</span></label>
                                            <HStack wrap spacing={10}>
                                                <VStack>
                                                    <label>บ้านเลขที่</label>
                                                    <Input
                                                        className='FhdwI'
                                                        size='sm'
                                                        style={{ width: 90 }}
                                                        defaultValue={this.state.reg_house_number}
                                                        onChange={e => this.setState({ reg_house_number: e })} />
                                                </VStack>
                                                <VStack>
                                                    <label>หมู่ที่</label>
                                                    <Input
                                                        className='JQT0l'
                                                        size='sm'
                                                        style={{ width: 60 }}
                                                        defaultValue={this.state.reg_village_no}
                                                        onChange={e => this.setState({ reg_village_no: e })} />
                                                </VStack>
                                                <VStack>
                                                    <label>หมู่บ้าน</label>
                                                    <SelectPicker
                                                        className='Gu8R6'
                                                        size='lg'
                                                        placeholder='กรุณาเลือก'
                                                        data={this.state.villages}
                                                        style={{ width: 200 }}
                                                        defaultValue={this.state.reg_village}
                                                        onChange={async e => {
                                                            await this.promisedSetState({ reg_village: e })
                                                            await this.onRenderContent({ mode })
                                                        }}
                                                    />
                                                </VStack>
                                                {this.state.reg_village === 'other' && (
                                                    <VStack>
                                                        <label>โปรดระบุ (ชื่อหมู่บ้าน)</label>
                                                        <Input
                                                            className='O41wx'
                                                            size='sm'
                                                            style={{ width: 200 }}
                                                            defaultValue={this.state.reg_village_name}
                                                            onChange={e => this.setState({ reg_village_name: e })}
                                                        />
                                                    </VStack>
                                                )}
                                                <VStack>
                                                    <label>จังหวัด</label>
                                                    <SelectPicker
                                                        className='8Ai89'
                                                        size='lg'
                                                        placeholder='กรุณาเลือก'
                                                        data={this.state.reg_province_selection}
                                                        style={{ width: 200 }}
                                                        defaultValue={this.state.reg_province_id}
                                                        onSelect={async (v, i) => {
                                                            await this.promisedSetState({ reg_province: i.label, reg_province_id: i.value })
                                                            await this.handleProvinceChange({
                                                                value: i.value,
                                                                amphureKey: 'reg_amphur_selection',
                                                                tambonKey: 'reg_tambon_selection',
                                                                data
                                                            })
                                                        }}
                                                        onClean={() => this.setState({ reg_province: '', reg_province_id: 0 })}
                                                    />
                                                </VStack>
                                                <VStack>
                                                    <label>อำเภอ</label>
                                                    <SelectPicker
                                                        className='vh44f'
                                                        size='lg'
                                                        placeholder='กรุณาเลือก'
                                                        data={this.state.reg_amphur_selection}
                                                        style={{ width: 200 }}
                                                        defaultValue={this.state.reg_amphur_id}
                                                        onSelect={async (v, i) => {
                                                            await this.promisedSetState({ reg_amphur: i.label, reg_amphur_id: i.value })
                                                            await this.handleAmphureChange({
                                                                value: i.value,
                                                                tambonKey: 'reg_tambon_selection',
                                                                data
                                                            })
                                                        }}
                                                    />
                                                </VStack>
                                                <VStack>
                                                    <label>ตำบล</label>
                                                    <SelectPicker
                                                        className='FbFav'
                                                        size='lg'
                                                        placeholder='กรุณาเลือก'
                                                        data={this.state.reg_tambon_selection}
                                                        style={{ width: 200 }}
                                                        defaultValue={this.state.reg_tambon_id}
                                                        onSelect={(v, i) => {
                                                            this.setState({ reg_tambon: i.label, reg_tambon_id: i.value })
                                                        }}
                                                    />
                                                </VStack>
                                            </HStack>
                                        </Col>
                                    </Row>

                                    <Row>
                                        <Col className="mb-3">
                                            <VStack>
                                                <label>ที่อยู่จริงในปัจจุบัน <span style={{ color: 'red' }}>*</span></label>
                                                <RadioGroup
                                                    className='Socam'
                                                    name="is_reg_address"
                                                    defaultValue={this.state.is_reg_address}
                                                    onChange={async e => {
                                                        await this.promisedSetState({ is_reg_address: e });
                                                        await this.onRenderContent({ mode: 'read' });
                                                    }}
                                                >
                                                    <Radio value="yes">อาศัยอยู่ตามที่อยู่ในทะเบียนบ้าน</Radio>
                                                    <Radio value="no">ไม่ได้อาศัยอยู่ตามทะเบียนบ้าน</Radio>
                                                </RadioGroup>

                                                {this.state.is_reg_address === 'no' && (
                                                    <div className="mt-2">
                                                        <Stack wrap spacing={10}>
                                                            <VStack>
                                                                <label>บ้านเลขที่</label>
                                                                <Input
                                                                    className='tKSCo'
                                                                    size='sm'
                                                                    style={{ width: 90 }}
                                                                    defaultValue={this.state.temp_house_number}
                                                                    onChange={e => this.setState({ temp_house_number: e })} />
                                                            </VStack>
                                                            <VStack>
                                                                <label>หมู่ที่</label>
                                                                <Input
                                                                    className='91Yvk'
                                                                    size='sm'
                                                                    style={{ width: 60 }}
                                                                    defaultValue={this.state.temp_village_no}
                                                                    onChange={e => this.setState({ temp_village_no: e })} />
                                                            </VStack>
                                                            <VStack>
                                                                <label>หมู่บ้าน</label>
                                                                <SelectPicker
                                                                    className='NiJXp'
                                                                    size='lg'
                                                                    placeholder='กรุณาเลือก'
                                                                    data={this.state.villages}
                                                                    style={{ width: 200 }}
                                                                    defaultValue={this.state.temp_village}
                                                                    onChange={async e => {
                                                                        await this.promisedSetState({ temp_village: e })
                                                                        await this.onRenderContent({ mode })
                                                                    }}
                                                                />
                                                            </VStack>
                                                            {this.state.temp_village === 'other' && (
                                                                <VStack>
                                                                    <label>โปรดระบุ (ชื่อหมู่บ้าน)</label>
                                                                    <Input
                                                                        className='23fiY'
                                                                        size='sm'
                                                                        style={{ width: 200 }}
                                                                        defaultValue={this.state.temp_village_name}
                                                                        onChange={e => this.setState({ temp_village_name: e })}
                                                                    />
                                                                </VStack>
                                                            )}

                                                            <VStack>
                                                                <label>จังหวัด</label>
                                                                <SelectPicker
                                                                    className='GzVd1'
                                                                    size='lg'
                                                                    placeholder='กรุณาเลือก'
                                                                    data={this.state.temp_province_selection}
                                                                    style={{ width: 200 }}
                                                                    defaultValue={this.state.temp_province_id}
                                                                    onSelect={async (v, i) => {
                                                                        await this.promisedSetState({ temp_province: i.label, temp_province_id: i.value })
                                                                        await this.handleProvinceChange({
                                                                            value: i.value,
                                                                            amphureKey: 'temp_amphur_selection',
                                                                            tambonKey: 'temp_tambon_selection',
                                                                            data
                                                                        })
                                                                    }}
                                                                    onClean={() => this.setState({ temp_province: '', temp_province_id: 0 })}
                                                                />
                                                            </VStack>
                                                            <VStack>
                                                                <label>อำเภอ</label>
                                                                <SelectPicker
                                                                    className='nfZ7a'
                                                                    size='lg'
                                                                    placeholder='กรุณาเลือก'
                                                                    data={this.state.temp_amphur_selection}
                                                                    style={{ width: 200 }}
                                                                    defaultValue={this.state.temp_amphur_id}
                                                                    onSelect={async (v, i) => {
                                                                        await this.promisedSetState({ reg_amphur: i.label, reg_amphur_id: i.value })
                                                                        await this.handleAmphureChange({
                                                                            value: i.value,
                                                                            tambonKey: 'temp_tambon_selection',
                                                                            data
                                                                        })
                                                                    }}
                                                                />
                                                            </VStack>
                                                            <VStack>
                                                                <label>ตำบล</label>
                                                                <SelectPicker
                                                                    className='4dIdR'
                                                                    size='lg'
                                                                    placeholder='กรุณาเลือก'
                                                                    data={this.state.temp_tambon_selection}
                                                                    style={{ width: 200 }}
                                                                    defaultValue={this.state.temp_tambon_id}
                                                                    onSelect={(v, i) => {
                                                                        this.setState({ temp_tambon: i.label, temp_tambon_id: i.value })
                                                                    }}
                                                                />
                                                            </VStack>
                                                        </Stack>
                                                    </div>
                                                )}
                                            </VStack>

                                            <Divider />

                                            <Text weight="bold">ข้อมูลครอบครัว</Text>

                                            <Row className='mt-3'>
                                                <Col lg={6}>
                                                    <VStack>
                                                        <label>ชื่อ-นามสกุล บิดา (ผู้ให้กำเนิด) <span style={{ color: 'red' }}>*</span></label>
                                                        <Input
                                                            className='FZxHD'
                                                            size='sm'
                                                            defaultValue={this.state.father_full_name}
                                                            onChange={e => this.setState({ father_full_name: e })} />
                                                    </VStack>
                                                </Col>
                                            </Row>
                                            <Row className='mt-3'>
                                                <Col lg={1}>
                                                    <VStack>
                                                        <label>อายุบิดา <span style={{ color: 'red' }}>*</span></label>
                                                        <InputNumber
                                                            className='Rf8OE'
                                                            size='lg'
                                                            defaultValue={this.state.father_age}
                                                            onChange={e => this.setState({ father_age: e })} />
                                                    </VStack>
                                                </Col>
                                                <Col lg={3} className='md-3'>
                                                    <VStack>
                                                        <label>หมายเลขโทรศัพท์ของบิดา <span style={{ color: 'red' }}>*</span></label>
                                                        <Input
                                                            className='9CtQT'
                                                            size='sm'
                                                            defaultValue={this.state.father_phone}
                                                            onChange={e => this.setState({ father_phone: e })} />
                                                    </VStack>
                                                </Col>
                                            </Row>
                                            <Row className='mt-3'>
                                                <Col lg={4} className='md-3'>
                                                    <VStack>
                                                        <label>อาชีพของบิดา <span style={{ color: 'red' }}>*</span></label>
                                                        <Input
                                                            className='a5fqJ'
                                                            size='sm'
                                                            defaultValue={this.state.father_occupation}
                                                            onChange={e => this.setState({ father_occupation: e })} />
                                                    </VStack>
                                                </Col>
                                                <Col lg={4} className='md-3'>
                                                    <VStack>
                                                        <label>สถานที่ทำงานของบิดา <span style={{ color: 'red' }}>*</span></label>
                                                        <Input
                                                            className='9mWs5'
                                                            size='sm'
                                                            defaultValue={this.state.father_workplace}
                                                            onChange={e => this.setState({ father_workplace: e })} />
                                                    </VStack>
                                                </Col>
                                            </Row>
                                            <Row className='mt-3'>
                                                <Col lg={4} className='md-3'>
                                                    <VStack>
                                                        <label>ชื่อ-นามสกุล มารดา (ผู้ให้กำเนิด) <span style={{ color: 'red' }}>*</span></label>
                                                        <Input
                                                            className='xBki4'
                                                            size='sm'
                                                            defaultValue={this.state.mother_full_name}
                                                            onChange={e => this.setState({ mother_full_name: e })} />
                                                    </VStack>
                                                </Col>
                                            </Row>
                                            <Row className='mt-3'>
                                                <Col lg={1} className='md-3'>
                                                    <VStack>
                                                        <label>อายุมารดา <span style={{ color: 'red' }}>*</span></label>
                                                        <InputNumber
                                                            className='JluQP'
                                                            size='lg'
                                                            defaultValue={this.state.mother_age}
                                                            onChange={e => this.setState({ mother_age: e })} />
                                                    </VStack>
                                                </Col>
                                                <Col lg={3} className='md-3'>
                                                    <VStack>
                                                        <label>หมายเลขโทรศัพท์ของมารดา <span style={{ color: 'red' }}>*</span></label>
                                                        <Input
                                                            className='bUaBd'
                                                            size='sm'
                                                            defaultValue={this.state.mother_phone}
                                                            onChange={e => this.setState({ mother_phone: e })} />
                                                    </VStack>
                                                </Col>
                                            </Row>
                                            <Row className='mt-3'>
                                                <Col lg={4} className='md-3'>
                                                    <VStack>
                                                        <label>อาชีพของมารดา <span style={{ color: 'red' }}>*</span></label>
                                                        <Input
                                                            className='bu0Vt'
                                                            size='sm'
                                                            defaultValue={this.state.mother_occupation}
                                                            onChange={e => this.setState({ mother_occupation: e })} />
                                                    </VStack>
                                                </Col>
                                                <Col lg={4} className='md-3'>
                                                    <VStack>
                                                        <label>สถานที่ทำงานมารดา <span style={{ color: 'red' }}>*</span></label>
                                                        <Input
                                                            className='qkjD3'
                                                            size='sm'
                                                            defaultValue={this.state.mother_workplace}
                                                            onChange={e => this.setState({ mother_workplace: e })} />
                                                    </VStack>
                                                </Col>
                                            </Row>
                                            <Row className='mt-3'>
                                                <Col>
                                                    <VStack>
                                                        <label>
                                                            สถานะของบิดา มารดา <span style={{ color: 'red' }}>*</span>
                                                        </label>
                                                        <RadioGroup
                                                            className='8Hj17'
                                                            name="parent_status"
                                                            defaultValue={this.state.parent_status}
                                                            onChange={e => this.setState({ parent_status: e }, () => this.onRenderContent({ mode }))}
                                                        >
                                                            <Radio value="บิดา มารดาอยู่ด้วยกัน">บิดา มารดาอยู่ด้วยกัน</Radio>

                                                            <Radio value="เสียชีวิตทั้งคู่ ปัจจุบันอาศัยอยู่กับ">
                                                                เสียชีวิตทั้งคู่ ปัจจุบันอาศัยอยู่กับ
                                                            </Radio>
                                                            {this.state.parent_status === 'เสียชีวิตทั้งคู่ ปัจจุบันอาศัยอยู่กับ' && (
                                                                <Input
                                                                    className='AJcGe'
                                                                    size='sm'
                                                                    placeholder='กรุณาระบุผู้ที่อาศัยอยู่ด้วย'
                                                                    defaultValue={this.state.parent_status_1}
                                                                    onChange={e => this.setState({ parent_status_1: e })}
                                                                />
                                                            )}

                                                            <Radio value="บิดาหรือมารดาคนใดคนหนึ่งเสียชีวิต ปัจจุบันอาศัยอยู่กับ">
                                                                บิดาหรือมารดาคนใดคนหนึ่งเสียชีวิต ปัจจุบันอาศัยอยู่กับ
                                                            </Radio>
                                                            {this.state.parent_status === 'บิดาหรือมารดาคนใดคนหนึ่งเสียชีวิต ปัจจุบันอาศัยอยู่กับ' && (
                                                                <Input
                                                                    className='ivHNl'
                                                                    size='sm'
                                                                    placeholder='กรุณาระบุผู้ที่อาศัยอยู่ด้วย'
                                                                    defaultValue={this.state.parent_status_2}
                                                                    onChange={e => this.setState({ parent_status_2: e })}
                                                                />
                                                            )}

                                                            <Radio value="บิดา มารดาแยกทางกัน ปัจจุบันอาศัยอยู่กับ">
                                                                บิดา มารดาแยกทางกัน ปัจจุบันอาศัยอยู่กับ
                                                            </Radio>
                                                            {this.state.parent_status === 'บิดา มารดาแยกทางกัน ปัจจุบันอาศัยอยู่กับ' && (
                                                                <Input
                                                                    className='TdekG'
                                                                    size='sm'
                                                                    placeholder='กรุณาระบุผู้ที่อาศัยอยู่ด้วย'
                                                                    defaultValue={this.state.parent_status_3}
                                                                    onChange={e => this.setState({ parent_status_3: e })}
                                                                />
                                                            )}

                                                            <Radio value="อื่นๆ โปรดระบุ">อื่นๆ โปรดระบุ</Radio>
                                                            {this.state.parent_status === 'อื่นๆ โปรดระบุ' && (
                                                                <Input
                                                                    className='AJbB5'
                                                                    size='sm'
                                                                    placeholder='โปรดระบุ'
                                                                    defaultValue={this.state.parent_status_4}
                                                                    onChange={e => this.setState({ parent_status_4: e })}
                                                                />
                                                            )}
                                                        </RadioGroup>
                                                    </VStack>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className='mt-3'>
                                                    <Stack wrap spacing={6}>
                                                        <span>ผู้ปกครองที่สามารถติดต่อได้ <span style={{ color: 'red' }}>*</span></span>
                                                        <Input
                                                            className='wPjjo'
                                                            size='sm'
                                                            style={{ width: 220 }}
                                                            defaultValue={this.state.contactable}
                                                            onChange={e => this.setState({ contactable: e })} />
                                                        <span>ความเกี่ยวข้องกับผู้สมัคร <span style={{ color: 'red' }}>*</span></span>
                                                        <Input
                                                            className='JRK1y'
                                                            size='sm'
                                                            style={{ width: 220 }}
                                                            defaultValue={this.state.relationship_to_applicant}
                                                            onChange={e => this.setState({ relationship_to_applicant: e })} />
                                                    </Stack>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className='mt-3'>
                                                    <HStack>
                                                        <span>จำนวนพี่น้องร่วมบิดามารดา (ไม่รวมผู้สมัคร) <span style={{ color: 'red' }}>*</span></span>
                                                        <InputNumber
                                                            className='Bn4wK'
                                                            size='lg'
                                                            defaultValue={this.state.total_siblings}
                                                            max={20}
                                                            min={0}
                                                            style={{ width: 60 }}
                                                            onChange={e => this.setState({ total_siblings: e })} />
                                                    </HStack>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className='mt-3'>
                                                    <HStack>
                                                        <span>จำนวนพี่น้องที่ทำงานแล้ว <span style={{ color: 'red' }}>*</span></span>
                                                        <InputNumber
                                                            className='ZcgUv'
                                                            size='lg'
                                                            defaultValue={this.state.working_siblings}
                                                            max={20}
                                                            min={0}
                                                            style={{ width: 60 }}
                                                            onChange={e => this.setState({ working_siblings: e })} />
                                                        <span>คน</span>
                                                    </HStack>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className='mt-3'>
                                                    <HStack>
                                                        <span>จำนวนพี่น้องที่เรียนอยู่ <span style={{ color: 'red' }}>*</span></span>
                                                        <InputNumber
                                                            className='kMMat'
                                                            size='lg'
                                                            defaultValue={this.state.siblings_in_school}
                                                            max={20}
                                                            min={0}
                                                            style={{ width: 60 }}
                                                            onChange={e => this.setState({ siblings_in_school: e })} />
                                                        <span>คน</span>
                                                    </HStack>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className='mt-3'>
                                                    <HStack>
                                                        <span>จำนวนพี่น้องที่ว่างงาน <span style={{ color: 'red' }}>*</span></span>
                                                        <InputNumber
                                                            className='Rw3oh'
                                                            size='lg'
                                                            defaultValue={this.state.unemployed_siblings}
                                                            max={20}
                                                            min={0}
                                                            style={{ width: 60 }}
                                                            onChange={e => this.setState({ unemployed_siblings: e })} />
                                                        <span>คน</span>
                                                    </HStack>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className='mt-3'>
                                                    <HStack>
                                                        <span>จำนวนพี่น้องที่ยังไม่ถึงวัยเรียน <span style={{ color: 'red' }}>*</span></span>
                                                        <InputNumber
                                                            className='NGcAJ'
                                                            size='lg'
                                                            defaultValue={this.state.siblings_not_of_age}
                                                            max={20}
                                                            min={0}
                                                            style={{ width: 60 }}
                                                            onChange={e => this.setState({ siblings_not_of_age: e })} />
                                                        <span>คน</span>
                                                    </HStack>
                                                </Col>
                                            </Row>
                                            <Row className='mt-3'>
                                                <Col>
                                                    <VStack>
                                                        <label>รายได้รวมต่อปีของครอบครัว (รวมรายได้ของบิดา/มารดา/พี่น้องที่ทำงานแล้ว) <span style={{ color: 'red' }}>*</span></label>
                                                        <HStack>
                                                            <InputNumber
                                                                className='q4vaA'
                                                                size='lg'
                                                                defaultValue={this.state.family_income_per_year}
                                                                min={0}
                                                                formatter={this.to2decimal}
                                                                style={{ width: 180 }}
                                                                onChange={e => this.setState({ family_income_per_year: e })}
                                                            />
                                                            <span>บาท/ปี</span>
                                                        </HStack>
                                                    </VStack>
                                                </Col>
                                            </Row>
                                            <Row className='mt-3'>
                                                <label>ผู้ที่สนับสนุนค่าใช้จ่ายในชีวิตประจำวัน/ค่าใช้จ่ายในการเรียนของผู้สมัคร <span style={{ color: 'red' }}>*</span></label>
                                                <Col lg={4} className='md-3'>
                                                    <VStack className='mt-2'>
                                                        <span>ชื่อ-นามสกุล</span>
                                                        <Input
                                                            className='X1Ej7'
                                                            size='sm'
                                                            defaultValue={this.state.provider_full_name}
                                                            onChange={e => this.setState({ provider_full_name: e })} />
                                                    </VStack>
                                                </Col>
                                                <Col lg={4} className='md-3'>
                                                    <VStack className='mt-2'>
                                                        <span>ความเกี่ยวข้องกับผู้สมัคร</span>
                                                        <Input
                                                            className='eRL0p'
                                                            size='sm'
                                                            defaultValue={this.state.provider_relationship}
                                                            onChange={e => this.setState({ provider_relationship: e })} />
                                                    </VStack>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className='mt-3'>
                                                    <VStack>
                                                        <span>ที่อยู่ (บ้าน/ที่อยู่อาศัย) ของครอบครัว <span style={{ color: 'red' }}>*</span></span>
                                                        <RadioGroup
                                                            className='BVUdW'
                                                            defaultValue={this.state.is_family_residence}
                                                            onChange={e => this.setState({ is_family_residence: e })} >
                                                            <Stack wrap spacing={8}>
                                                                <Radio value="yes">มีบ้าน/ที่อยู่อาศัยเป็นของครอบครัว</Radio>
                                                                <HStack>
                                                                    <span>จำนวน</span>
                                                                    <InputNumber
                                                                        className='hCvs8'
                                                                        size='lg'
                                                                        defaultValue={this.state.family_residence_rai}
                                                                        min={0}
                                                                        style={{ width: 80 }}
                                                                        onChange={e => this.setState({ family_residence_rai: e })} />
                                                                    <span>ไร่</span>
                                                                </HStack>

                                                                <HStack>
                                                                    <InputNumber
                                                                        className='jDlcP'
                                                                        size='lg'
                                                                        defaultValue={this.state.family_residence_ngan}
                                                                        min={0}
                                                                        style={{ width: 80 }}
                                                                        onChange={e => this.setState({ family_residence_ngan: e })} />
                                                                    <span>งาน</span>
                                                                </HStack>

                                                                <HStack>
                                                                    <InputNumber
                                                                        className='pPUkn'
                                                                        size='lg'
                                                                        defaultValue={this.state.family_residence_wah}
                                                                        min={0}
                                                                        style={{ width: 80 }}
                                                                        onChange={e => this.setState({ family_residence_wah: e })} />
                                                                    <span>ตารางวา</span>
                                                                </HStack>
                                                            </Stack>
                                                            <Stack wrap spacing={6}>
                                                                <Radio value="no">ไม่มีบ้าน/ที่อยู่อาศัยของครอบครัว</Radio>
                                                            </Stack>
                                                        </RadioGroup>
                                                    </VStack>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className='mt-3'>
                                                    <VStack>
                                                        <span>ที่ทำกินของครอบครัว <span style={{ color: 'red' }}>*</span></span>
                                                        <RadioGroup
                                                            className='kRB1A'
                                                            defaultValue={this.state.is_family_work}
                                                            onChange={e => this.setState({ is_family_work: e })} >
                                                            <Stack wrap spacing={8}>
                                                                <Radio value="yes">มีที่ทำกินเป็นของครอบครัว</Radio>
                                                                <HStack>
                                                                    <span>จำนวน</span>
                                                                    <InputNumber
                                                                        className='uFfrT'
                                                                        size='lg'
                                                                        defaultValue={this.state.family_work_rai}
                                                                        min={0}
                                                                        style={{ width: 80 }}
                                                                        onChange={e => this.setState({ family_work_rai: e })} />
                                                                    <span>ไร่</span>
                                                                </HStack>

                                                                <HStack>
                                                                    <InputNumber
                                                                        className='kUvhI'
                                                                        size='lg'
                                                                        defaultValue={this.state.family_work_ngan}
                                                                        min={0}
                                                                        style={{ width: 80 }}
                                                                        onChange={e => this.setState({ family_work_ngan: e })} />
                                                                    <span>งาน</span>
                                                                </HStack>

                                                                <HStack>
                                                                    <InputNumber
                                                                        className='MFBjU'
                                                                        size='lg'
                                                                        defaultValue={this.state.family_work_wah}
                                                                        min={0}
                                                                        style={{ width: 80 }}
                                                                        onChange={e => this.setState({ family_work_wah: e })} />
                                                                    <span>ตารางวา</span>
                                                                </HStack>
                                                            </Stack>
                                                            <Stack wrap spacing={6}>
                                                                <Radio value="no">ไม่มีที่ทำกินของครอบครัว</Radio>
                                                            </Stack>
                                                        </RadioGroup>
                                                    </VStack>
                                                </Col>
                                            </Row>
                                              <Row>
                                                <Col className='mt-3'>
                                                    <VStack>
                                                        <span>ที่อยู่ (บ้าน/ที่อยู่อาศัย) นอกพื้นที่ <span style={{ color: 'red' }}>*</span></span>
                                                        <RadioGroup
                                                            className='E1jrr'
                                                            defaultValue={this.state.is_none_residence}
                                                            onChange={e => this.setState({ is_none_residence: e })} >
                                                            <Stack wrap spacing={8}>
                                                                <Radio value="yes">มีบ้าน/ที่อยู่อาศัยนอกพื้นที่</Radio>
                                                                <HStack>
                                                                    <span>จำนวน</span>
                                                                    <InputNumber
                                                                        className='ovtgo'
                                                                        size='lg'
                                                                        defaultValue={this.state.none_residence_rai}
                                                                        min={0}
                                                                        style={{ width: 80 }}
                                                                        onChange={e => this.setState({ none_residence_rai: e })} />
                                                                    <span>ไร่</span>
                                                                </HStack>

                                                                <HStack>
                                                                    <InputNumber
                                                                        className='7lTnN'
                                                                        size='lg'
                                                                        defaultValue={this.state.none_residence_ngan}
                                                                        min={0}
                                                                        style={{ width: 80 }}
                                                                        onChange={e => this.setState({ none_residence_ngan: e })} />
                                                                    <span>งาน</span>
                                                                </HStack>

                                                                <HStack>
                                                                    <InputNumber
                                                                        className='1B4bF'
                                                                        size='lg'
                                                                        defaultValue={this.state.none_residence_wah}
                                                                        min={0}
                                                                        style={{ width: 80 }}
                                                                        onChange={e => this.setState({ none_residence_wah: e })} />
                                                                    <span>ตารางวา</span>
                                                                </HStack>
                                                            </Stack>
                                                            <Stack wrap spacing={6}>
                                                                <Radio value="no">ไม่มีบ้าน/ที่อยู่อาศัยนอกพื้นที่</Radio>
                                                            </Stack>
                                                        </RadioGroup>
                                                    </VStack>
                                                </Col>
                                            </Row>
                                            <Row>
                                                <Col className='mt-3'>
                                                    <VStack>
                                                        <span>ที่ทำกินนอกพื้นที่ <span style={{ color: 'red' }}>*</span></span>
                                                        <RadioGroup
                                                            className='GwPZa'
                                                            defaultValue={this.state.is_none_work}
                                                            onChange={e => this.setState({ is_none_work: e })} >
                                                            <Stack wrap spacing={8}>
                                                                <Radio value="yes">มีที่ทำกินนอกพื้นที่</Radio>
                                                                <HStack>
                                                                    <span>จำนวน</span>
                                                                    <InputNumber
                                                                        className='aw8zL'
                                                                        size='lg'
                                                                        defaultValue={this.state.none_work_rai}
                                                                        min={0}
                                                                        style={{ width: 80 }}
                                                                        onChange={e => this.setState({ none_work_rai: e })} />
                                                                    <span>ไร่</span>
                                                                </HStack>

                                                                <HStack>
                                                                    <InputNumber
                                                                        className='4Hodl'
                                                                        size='lg'
                                                                        defaultValue={this.state.none_work_ngan}
                                                                        min={0}
                                                                        style={{ width: 80 }}
                                                                        onChange={e => this.setState({ none_work_ngan: e })} />
                                                                    <span>งาน</span>
                                                                </HStack>

                                                                <HStack>
                                                                    <InputNumber
                                                                        className='vuj6D'
                                                                        size='lg'
                                                                        defaultValue={this.state.none_work_wah}
                                                                        min={0}
                                                                        style={{ width: 80 }}
                                                                        onChange={e => this.setState({ none_work_wah: e })} />
                                                                    <span>ตารางวา</span>
                                                                </HStack>
                                                            </Stack>
                                                            <Stack wrap spacing={6}>
                                                                <Radio value="no">ไม่มีที่ทำกินนอกพื้นที่</Radio>
                                                            </Stack>
                                                        </RadioGroup>
                                                    </VStack>
                                                </Col>
                                            </Row>
                                        </Col>
                                    </Row>
                                    <hr />
                                    <HStack className="mt-3" justifyContent="space-between" style={{ width: '100%' }}>
                                        {/* ปุ่มซ้าย */}
                                        <Button
                                            appearance="primary"
                                            startIcon={<i className="bi bi-floppy-fill"></i>}
                                            onClick={() => this.onConfirm({ mode: 'insert', id: this.state.id })}
                                        >
                                            บันทึก
                                        </Button>

                                        {/* ปุ่มขวา */}
                                        <Button
                                            endIcon={<i className="bi bi-chevron-right"></i>}
                                            onClick={() => Swal.fire({
                                                title: 'คุณต้องการกลับหน้าแรกหรือไม่?',
                                                showCancelButton: true,
                                                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                                                cancelButtonText: `<div style="font-size: 1.425rem">ยกเลิก</div>`,
                                                confirmButtonColor: '#3085d6',
                                                cancelButtonColor: '#d33',
                                            }).then((result) => {
                                                if (result.isConfirmed) {
                                                    window.location.href = '../profile';
                                                }
                                            })}
                                        >
                                            กลับหน้าแรก
                                        </Button>
                                    </HStack>

                                </Panel>
                            </Col>
                        </Row>
                    </>
                })

                await this.promisedSetState({ loading: false })

            } catch (error) {
                // Handle errors here
                console.error('Error fetching data or rendering content:', error);

                // Redirect to Log In
                window.location.href = '/login';
            }
        }
    };

    Validate = async (value, className, expected = '') => {
        try {
            // Trim ค่า string เพื่อกัน user ใส่ช่องว่างเปล่า
            const input = typeof value === 'string' ? value.trim() : value;

            // ตรวจสอบว่า className ถูกต้องหรือไม่
            if (!className || typeof className !== 'string') {
                console.warn(`Invalid className: "${className}"`);
                return false;
            }

            // เปรียบเทียบค่า input กับ expected
            const isValid = input !== expected;

            const $element = $('.' + className);
            if (!$element.length) {
                console.warn(`DOM element with class ".${className}" not found.`);
            }

            if (!isValid) {
                $element.addClass('required');

                await Swal.fire({
                    title: "กรุณากรอกข้อมูลให้ครบถ้วน",
                    icon: "warning",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                });

                return false;
            } else {
                $element.removeClass('required');
                return true;
            }
        } catch (error) {
            console.error('Validation error:', error);
            return false;
        }
    };

    onConfirm = async ({ id }) => {
        const validateForm = async () => {
            const validationPromises = [
                this.Validate(this.state.prefix, 'tMeny', ''),
                this.Validate(this.state.first_name, 'vKmhs', ''),
                this.Validate(this.state.last_name, 'PA9y5', ''),
                this.Validate(this.state.nickname, 'AA0HY', ''),
                this.Validate(this.state.id_card_number, 'IoXlX', ''),
                this.Validate(this.state.date_of_birth, 'QA6Vy', ''),
                this.Validate(this.state.ethnicity, '0i8nv', ''),
                this.Validate(this.state.phone, 'y013L', ''),
                this.Validate(this.state.reg_house_number, 'FhdwI', ''),
                this.Validate(this.state.reg_village_no, 'JQT0l', ''),
                this.Validate(this.state.reg_village, 'Gu8R6', ''),
                ...(this.state.reg_village === 'other' ? [
                    this.Validate(this.state.reg_village_name, 'O41wx', ''),
                ] : []),
                this.Validate(this.state.reg_province, '8Ai89', ''),
                this.Validate(this.state.reg_amphur, 'vh44f', ''),
                this.Validate(this.state.reg_tambon, 'FbFav', ''),
                ...(this.state.is_reg_address === 'no' ? [
                    this.Validate(this.state.temp_house_number, 'tKSCo', ''),
                    this.Validate(this.state.temp_village_no, '91Yvk', ''),
                    this.Validate(this.state.temp_village, 'NiJXp', ''),
                    ...(this.state.temp_village === 'other' ? [
                        this.Validate(this.state.temp_village_name, '23fiY', ''),
                    ] : []),
                    this.Validate(this.state.temp_province, 'GzVd1', ''),
                    this.Validate(this.state.temp_amphur, 'nfZ7a', ''),
                    this.Validate(this.state.temp_tambon, '4dIdR', ''),
                ] : []),
                this.Validate(this.state.father_full_name, 'FZxHD', ''),
                this.Validate(this.state.father_age, 'Rf8OE', ''),
                this.Validate(this.state.father_phone, '9CtQT', ''),
                this.Validate(this.state.father_occupation, 'a5fqJ', ''),
                this.Validate(this.state.father_workplace, '9mWs5', ''),
                this.Validate(this.state.mother_full_name, 'xBki4', ''),
                this.Validate(this.state.mother_age, 'JluQP', ''),
                this.Validate(this.state.mother_phone, 'bUaBd', ''),
                this.Validate(this.state.mother_occupation, 'bu0Vt', ''),
                this.Validate(this.state.mother_workplace, 'qkjD3', ''),
                ...(this.state.parent_status === 'เสียชีวิตทั้งคู่ ปัจจุบันอาศัยอยู่กับ' ? [
                    this.Validate(this.state.parent_status_1, 'AJcGe', ''),
                ] : []),
                ...(this.state.parent_status === 'บิดาหรือมารดาคนใดคนหนึ่งเสียชีวิต ปัจจุบันอาศัยอยู่กับ' ? [
                    this.Validate(this.state.parent_status_2, 'ivHNl', ''),
                ] : []),
                ...(this.state.parent_status === 'บิดา มารดาแยกทางกัน ปัจจุบันอาศัยอยู่กับ' ? [
                    this.Validate(this.state.parent_status_3, 'TdekG', ''),
                ] : []),
                ...(this.state.parent_status === 'อื่นๆ โปรดระบุ' ? [
                    this.Validate(this.state.parent_status_4, 'AJbB5', ''),
                ] : []),
                this.Validate(this.state.relationship_to_applicant, 'JRK1y', ''),
                this.Validate(this.state.total_siblings, 'Bn4wK', ''),
                this.Validate(this.state.working_siblings, 'ZcgUv', ''),
                this.Validate(this.state.siblings_in_school, 'kMMat', ''),
                this.Validate(this.state.unemployed_siblings, 'Rw3oh', ''),
                this.Validate(this.state.siblings_not_of_age, 'NGcAJ', ''),
                this.Validate(this.state.family_income_per_year, 'q4vaA', ''),
                this.Validate(this.state.provider_full_name, 'X1Ej7', ''),
                this.Validate(this.state.provider_relationship, 'eRL0p', '')
            ];

            const results = await Promise.all(validationPromises);
            return results.every(r => r === true);
        };

        const isValid = await validateForm();

        if (!isValid) {
            return;
        }

        this.setState({ loading: true });

        try {
            const resImage = await fetch(this.state.croppedImage);
            const blob = await resImage.blob();
            const formData = new FormData();

            // 🔑 รายการ key แบบย่อ
            const keys = [
                'id', 'id_card_number', 'first_name', 'last_name', 'nickname', 'date_of_birth', 'ethnicity', 'phone',
                'reg_house_number', 'reg_village_no', 'reg_village', 'reg_village_name',
                'reg_province', 'reg_province_id', 'reg_amphur', 'reg_amphur_id', 'reg_tambon', 'reg_tambon_id', 'is_reg_address',
                'temp_house_number', 'temp_village_no', 'temp_village', 'temp_village_name',
                'temp_province', 'temp_province_id', 'temp_amphur', 'temp_amphur_id', 'temp_tambon', 'temp_tambon_id',
                'father_full_name', 'father_age', 'father_phone', 'father_occupation', 'father_workplace',
                'mother_full_name', 'mother_age', 'mother_phone', 'mother_occupation', 'mother_workplace',
                'parent_status', 'parent_status_1', 'parent_status_2', 'parent_status_3', 'parent_status_4',
                'contactable', 'relationship_to_applicant',
                'total_siblings', 'working_siblings', 'siblings_in_school', 'unemployed_siblings', 'siblings_not_of_age',
                'family_income_per_year', 'provider_full_name', 'provider_relationship',
                'is_family_residence', 'family_residence_rai', 'family_residence_ngan', 'family_residence_wah',
                'is_none_residence', 'none_residence_rai', 'none_residence_ngan', 'none_residence_wah',
                'is_family_work', 'family_work_rai', 'family_work_ngan', 'family_work_wah',
                'is_none_work', 'none_work_rai', 'none_work_ngan', 'none_work_wah'
            ];

            formData.append('image', blob, 'image.png');
            keys.forEach(key => formData.append(key, this.state[key]));

            const response = await axios.patch(`${process.env.REACT_APP_API}/application`, formData, this.state.authHeader);
            const data = response.data;

            if (data.message === 'successfully') {
                await this.promisedSetState({ loading: false });

                Swal.fire({
                    title: "บันทึกข้อมูลเรียบร้อยแล้ว",
                    icon: "success",
                    timer: 2000,
                    timerProgressBar: true,
                    confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
                }).then(async () => {
                    const logged = JSON.parse(localStorage.getItem('logged') || '{}');
                    const userId = logged?.user?.user?.id;
                    const { data } = await axios.get(`${process.env.REACT_APP_API}/application/latest/${userId}`, this.state.authHeader);
                    this.onRenderContent({ mode: 'read', data });
                });
            }
        } catch (error) {
            Swal.fire({
                title: "เกิดข้อผิดพลาด",
                icon: "error",
                text: error.message,
                confirmButtonText: `<div style="font-size: 1.425rem">ตกลง</div>`,
            });
            this.setState({ loading: false });
        }
    };

    render() {

        const FullPageLoader = () => (
            <div style={{
                position: 'fixed',
                top: 0,
                left: 0,
                width: '100%',
                height: '100%',
                backgroundColor: 'rgba(255, 255, 255, 0.8)', // Semi-transparent background
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                zIndex: 9999 // Ensure it's on top of other content
            }}>
                <Loader content="Loading..." /> {/* Adjust loader component as needed */}
            </div>
        );

        return (
            <>
                {this.state.content}
                {this.state.modal}
                {this.state.loading && <FullPageLoader />}
            </>
        );
    }
}
